const BUILDING_ID = 'buildingId';
const CATEGORY_ID = 'categoryId';
const PRODUCT_ID = 'productId';
const ASSET_ID = 'assetId';

export { BUILDING_ID, CATEGORY_ID, PRODUCT_ID, ASSET_ID };
